import { Options_POCUI } from "./Options_POCUI.tsx";
import { StandardProps } from "../componentMap";
import { productsRange } from "./data/productsRangeOptions.ts";
import { sellingProductTypes } from "./data/sellingProductTypes.ts";
import { getOptionsList, OptionsType } from "@/components/Options_POC/utils.ts";
import {
  ButtonSizeThreshold,
  buttonSizeThresholdConfigSchema,
} from "@/components/Sizes/config/buttonSizeThresholdConfigSchema.ts";

export function Options_POC({
  product,
  configProps,
  flags,
}: Pick<StandardProps, "product" | "configProps" | "flags">) {
  const buttonSizeStyleThreshold: ButtonSizeThreshold | undefined =
    buttonSizeThresholdConfigSchema.safeParse(
      configProps?.buttonSizeStyleThreshold,
    )?.data || undefined;
  const showOptionsRangeSelector =
    flags.showOptionsRangeSelector.value === true;
  const optionsList: OptionsType = getOptionsList(
    product,
    productsRange,
    sellingProductTypes,
  );

  if (!showOptionsRangeSelector || !optionsList.length) return null;

  return (
    <Options_POCUI
      options={optionsList.sort((a, b) => parseInt(a.name) - parseInt(b.name))}
      buttonSizeStyleThreshold={buttonSizeStyleThreshold}
    />
  );
}
